import { useState, type InputHTMLAttributes } from "react";

import { FormField } from "./FormField";
import "../Input.scss";

type TextFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  hint?: string;
  label?: string;
};

export function TextField({
  className = "",
  error,
  hint,
  label,
  type = "text",
  ...props
}: TextFieldProps) {
  const isPassword = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormField error={error} hint={hint} htmlFor={props.id} label={label}>
      <div className={`text-field ${isPassword ? "text-field--password" : ""}`.trim()}>
        <input
          className={`input ${className}`.trim()}
          type={isPassword && showPassword ? "text" : type}
          {...props}
        />
        {isPassword && (
          <button
            aria-label={showPassword ? "Hide password" : "Show password"}
            aria-pressed={showPassword}
            className="text-field-toggle"
            onClick={() => setShowPassword((visible) => !visible)}
            type="button"
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        )}
      </div>
    </FormField>
  );
}
